import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { Children, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MainContent } from "./MainContent/MainContent";
import { AirportPlaningAndDesign } from "./AirportPlaningAndDesign/AirportPlaningAndDesign";
import { AirportDevelopment } from "./AirportDevelopment/AirportDevelopment";
import { AirportOperationsAndAirportSystems } from "./AirportOperationsAndAirportSystems/AirportOperationsAndAirportSystems";
import { OverseasInvestments } from "./OverseasInvestments/OverseasInvestments";
import { AirportConsultancyAndOverseasVenturesPageHeading } from "./AirportConsultancyAndOverseasVenturesPageHeading";
import { AirportConsultancyNextPage } from "./MainContent/AirportConsultancyNextPage";

export const AirportConsultancyAndOverseasVentures = () => {
  const query = useQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if(query.get('id')){
      return;
    }
    const subActiveTab = query.get("subActiveTab");
    if (query.get("activeTab") === "airportConsultancy") {
      navigate(
        `/dedicated/corporate/business-oppurtunities?activeTab=airportConsultancy&subActiveTab=${subActiveTab ?? 'airportConsultancyPageHeading'}`,
        {
          replace: true,
        }
      );
    }
  }, [query.get("activeTab"), query.get('subActiveTab')]);

  const aboutEramanChildItems = [
    {
      label: "Page Heading",
      key: 'airportConsultancyPageHeading',
      children: <AirportConsultancyAndOverseasVenturesPageHeading/>
    },
    {
      label: "Main Content",
      key: 'mainContent',
      children: <MainContent/>
    },
    {
      label: "Airport Planning and Design",
      key: 'airportPlaningAndDesign',
      children: <AirportPlaningAndDesign/>
    },
    {
        label: "Airport Development",
        key: 'airportDevelopment',
        children: <AirportDevelopment/>
    },
    {
        label: "Airport Operations and Airport Systems",
        key: 'airportOperationsAndAirportSystems',
        children: <AirportOperationsAndAirportSystems/>
    },
    {
        label: "Overseas Investments",
        key: 'overseasInvestments',
        children: <OverseasInvestments/>
    },
    {
      label: "Next Page",
      key: "airportConsultancyNextPage",
      children: <AirportConsultancyNextPage/>
    },
  ];

  return (
    // <ContentWrapper title={"About Eraman"}>
      <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={aboutEramanChildItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
